import type { ValidationErrors } from '../../../../../utils/validation';
import type { ICustomControlData } from './customControlData';
import { RadioGroupField } from '../../../../fields/RadioGroup';

interface IPacemakerAddEditProps {
    customControlData: ICustomControlData;
    errors: ValidationErrors;
}

export function PacemakerAddEdit(props: IPacemakerAddEditProps) {
    return (
        <RadioGroupField
            automation="hasPacemaker"
            error={props.errors.get('customControlData.hasPacemaker')}
            fieldKey="hasPacemaker"
            hasErrors={props.errors.has('procedureCustomControlData.hasPacemaker')}
            isRequired
            label="Pacemaker"
            options={['Ja', 'Nee']}
            value={props.customControlData.hasPacemaker || 'Nee'}
        />
    );
}
